import React from 'react';

import { cn } from '~/lib/utils';

import { SKELETON_CARD_COUNT } from './constants';

interface CardGridSkeletonProps {
  count?: number;
  className?: string;
  children: React.ReactNode;
}

export function CardGridSkeleton({
  count = SKELETON_CARD_COUNT,
  className,
  children
}: CardGridSkeletonProps) {
  return (
    <div className={cn(className)} aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, index) => (
        <React.Fragment key={index}>{children}</React.Fragment>
      ))}
    </div>
  );
}
